import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {LooseObject} from '@/types';
import {genID} from '@/utils/helpers';

@Component
export default class BaseSelect extends Vue {
  @Prop() value!: any;
  @Prop() validationName!: string;
  @Prop() rules!: LooseObject;
  @Prop() vid!: string;

  innerValue: any = '';

  get providerName() {
    return (
      this.validationName ||
      this.$attrs.label ||
      this.$attrs.placeholder ||
      this.$attrs.name
    );
  }

  get defaultAttributes(): any {
    return {};
  }

  get label() {
    return this.$attrs.label;
  }

  get attributes() {
    const attrs = {...this.defaultAttributes, ...this.$attrs};
    delete attrs.label;
    return attrs;
  }

  get id() {
    return this.$attrs.id || `input-${genID()}`;
  }

  @Watch('value', {immediate: true})
  onValueChanged(val: any) {
    this.innerValue = val;
  }

  @Watch('innerValue')
  onInnerValueChanged(val: any) {
    this.$emit('input', val);
  }
}
